/* Frames the photos in a post written in the blog editor.

   The body of an article now comes from that editor, and it arrives as plain HTML: a
   heading is an <h2>, a pulled line is a <blockquote>, and a photo is a bare <img>. The
   first two are only type, so the section stamps the theme's heading classes on them in
   Liquid and they are done. The photo is not type — the Figma draws it inside two nested
   rings with an ornament hanging off each corner, which is six elements the editor has no
   way to write.

   So it is built here, out of exactly the markup sections/article.liquid writes for a
   Photo block, which means the two are the same component and article.css already styles
   this one.

   Photos placed one after another, with no copy between them, are a gallery: one frame
   holding a grid of thumbnails instead of a stack of 600px frames. The editor has no
   gallery of its own, so "consecutive" is the only way an author can say it — and it is
   the natural one, since dropping twenty photos in a row is how a post like that gets
   written anyway. A lone photo keeps the big frame.

   Progressive enhancement on purpose: article.css gives a bare image the ring on its own
   border, so a post whose script never ran still shows a framed photo rather than a naked
   one. This upgrade replaces it with the real thing. */
(function () {
    function toArray(list) {
        return Array.prototype.slice.call(list);
    }

    function isBlank(node) {
        return node.textContent.trim() === '';
    }

    // An empty paragraph, or a stray <br>, between two photos. The editor leaves these
    // behind when an author presses Enter between images, and they should not split a
    // gallery in two. Anything carrying meaning without text — a rule, an embed — does.
    function isSpacer(node) {
        return /^(P|DIV|BR|SPAN)$/.test(node.tagName)
            && isBlank(node)
            && !node.querySelector('img, iframe, video, hr, table');
    }

    // Walks the top-level children of the body and collects runs of photos. The editor
    // rarely gives an image a paragraph of its own — inserting one at the end of a
    // sentence leaves it inside that paragraph, and inserting several in a row often puts
    // them all in one p with <br>s between — so the unit is the top-level element, not the
    // image. A block-level figure inside a p is invalid, so the frame is always promoted to
    // sit beside the element that held the images, never built where they happened to sit.
    function collectRuns(body) {
        var runs = [];
        var run = null;
        var spacers = [];

        toArray(body.childNodes).forEach(function (node) {
            if (node.nodeType === 3) {
                if (!isBlank(node)) run = null;
                return;
            }
            if (node.nodeType !== 1) return;

            var images = node.tagName === 'IMG' ? [node] : toArray(node.querySelectorAll('img'));
            images = images.filter(function (image) {
                return !image.closest('.article-figure');
            });

            // Photos and nothing else: they join the run in progress, or open one.
            if (images.length && isBlank(node)) {
                if (!run) {
                    run = { anchor: node, after: false, images: [], hosts: [] };
                    runs.push(run);
                }
                run.images = run.images.concat(images);
                run.hosts = run.hosts.concat(spacers, node);
                spacers = [];
                return;
            }

            if (!images.length && isSpacer(node)) {
                if (run) spacers.push(node);
                return;
            }

            // Copy closes the run. Photos sharing a paragraph with copy open a new one,
            // placed after that paragraph, which the next image-only siblings can join.
            spacers = [];
            run = null;
            if (images.length) {
                run = { anchor: node, after: true, images: images, hosts: [node] };
                runs.push(run);
            }
        });

        return runs;
    }

    function corners(figure) {
        ['tl', 'tr', 'bl', 'br'].forEach(function (corner) {
            var span = document.createElement('span');
            span.className = 'article-figure__corner article-figure__corner--' + corner;
            figure.appendChild(span);
        });
    }

    /* THE LIGHTBOX

       A click on a gallery photo opens it in the dialog sections/article.liquid renders,
       with the arrows stepping through the rest of that gallery. The thumbnail is the
       800px copy the post asks the CDN for; the viewer asks for a 2000px one of the same
       file, since Shopify's CDN resizes by query string. A photo from anywhere else is
       shown at the URL it came with.

       No dialog on the page — a template older than this script — and the photos are
       simply not clickable, rather than clickable into nothing. */

    var lightbox = null;

    function large(src) {
        try {
            var url = new URL(src, window.location.href);
            if (/(^|\.)shopify\.com$/.test(url.hostname) || url.pathname.indexOf('/cdn/shop/') === 0) {
                url.searchParams.set('width', '2000');
            }
            return url.href;
        } catch (error) {
            return src;
        }
    }

    function setUpLightbox() {
        var dialog = document.querySelector('[data-article-lightbox]');
        if (!dialog || typeof dialog.showModal !== 'function') return null;

        // Built here and not in the section: the photo's size is unknown until one is picked.
        var image = document.createElement('img');
        image.className = 'article-lightbox__image';
        image.alt = '';
        var next = dialog.querySelector('[data-lightbox-next]');
        dialog.insertBefore(image, next);
        var count = dialog.querySelector('[data-lightbox-count]');
        var photos = [];
        var current = 0;

        function show(index) {
            current = (index + photos.length) % photos.length;
            var photo = photos[current];
            image.src = large(photo.currentSrc || photo.src);
            image.alt = photo.alt;
            count.textContent = (current + 1) + ' / ' + photos.length;

            // The neighbours, so stepping through does not wait on the network each time.
            [current - 1, current + 1].forEach(function (near) {
                var neighbour = photos[(near + photos.length) % photos.length];
                new Image().src = large(neighbour.currentSrc || neighbour.src);
            });
        }

        function step(by) {
            if (photos.length > 1) show(current + by);
        }

        dialog.querySelector('[data-lightbox-prev]').addEventListener('click', function () { step(-1); });
        next.addEventListener('click', function () { step(1); });
        dialog.querySelector('[data-lightbox-close]').addEventListener('click', function () { dialog.close(); });

        // A click on the dim around the photo closes, the way the drawers' scrim does. The
        // dialog fills the viewport, so that is any click whose target is the dialog itself.
        dialog.addEventListener('click', function (event) {
            if (event.target === dialog) dialog.close();
        });

        dialog.addEventListener('keydown', function (event) {
            if (event.key === 'ArrowLeft') step(-1);
            if (event.key === 'ArrowRight') step(1);
        });

        // Swipe on touch screens, where the arrows are a reach.
        var touchX = null;
        dialog.addEventListener('touchstart', function (event) {
            touchX = event.touches.length === 1 ? event.touches[0].clientX : null;
        }, { passive: true });
        dialog.addEventListener('touchend', function (event) {
            if (touchX === null) return;
            var dx = event.changedTouches[0].clientX - touchX;
            if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
            touchX = null;
        });

        // A modal dialog does not stop the page behind it scrolling under a wheel.
        dialog.addEventListener('close', function () {
            document.documentElement.classList.remove('article-lightbox-open');
            image.removeAttribute('src');
        });

        return {
            open: function (gallery, index) {
                photos = gallery;
                dialog.classList.toggle('article-lightbox--single', photos.length < 2);
                show(index);
                document.documentElement.classList.add('article-lightbox-open');
                dialog.showModal();
            }
        };
    }

    function build(run) {
        var gallery = run.images.length > 1;

        var figure = document.createElement('figure');
        figure.className = 'article-block article-block--image article-figure';

        var inner = document.createElement('span');
        inner.className = 'article-figure__inner';

        // Where the photos go: straight into the ring for a lone photo, into a grid inside
        // it for a gallery.
        var target = inner;

        if (gallery) {
            figure.classList.add('article-figure--gallery');
            inner.classList.add('article-gallery');

            target = document.createElement('span');
            target.className = 'article-gallery__grid';
            inner.appendChild(target);
        }

        var anchor = run.after ? run.anchor.nextSibling : run.anchor;
        run.anchor.parentNode.insertBefore(figure, anchor);

        run.images.forEach(function (image) {
            // The <br> the editor puts either side of an image exists to give it a line of
            // its own. Once the photo is in a frame, they are empty lines.
            [image.previousSibling, image.nextSibling].forEach(function (sibling) {
                if (sibling && sibling.nodeType === 1 && sibling.tagName === 'BR') sibling.remove();
            });

            image.classList.add('article-figure__image');
            if (!gallery) {
                inner.appendChild(image);
                return;
            }

            // Every cell is the same 3:2 box and the photo sits in it whole, so a portrait
            // leaves bands either side. They are filled with the same photo again, blurred
            // and dimmed — the same file, so it costs no second download — which is what
            // keeps a mixed gallery reading as a regular grid instead of one with holes.
            var cell = document.createElement(lightbox ? 'button' : 'span');
            cell.className = 'article-gallery__cell';
            if (lightbox) {
                cell.type = 'button';
                cell.setAttribute('aria-label', image.alt || 'Open photo');
            }

            var backdrop = document.createElement('img');
            backdrop.className = 'article-gallery__backdrop';
            backdrop.src = image.currentSrc || image.src;
            backdrop.alt = '';
            backdrop.setAttribute('aria-hidden', 'true');
            backdrop.loading = 'lazy';

            image.classList.add('article-gallery__image');
            cell.appendChild(backdrop);
            cell.appendChild(image);
            target.appendChild(cell);
        });

        figure.appendChild(inner);
        corners(figure);

        if (gallery && lightbox) {
            var photos = run.images;
            toArray(target.children).forEach(function (cell, index) {
                cell.addEventListener('click', function () { lightbox.open(photos, index); });
            });
        }

        // What the images were lifted out of, when that was all it held. An empty p still
        // takes a line-height, which reads as a gap nobody asked for.
        run.hosts.forEach(function (host) {
            if (host.tagName === 'IMG' || !host.parentNode) return;
            if (!host.querySelector('img') && isBlank(host)) host.remove();
        });
    }

    function run() {
        lightbox = setUpLightbox();
        document.querySelectorAll('.article-block--body .text--rich').forEach(function (body) {
            collectRuns(body).forEach(build);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})();
